import React from "reactn"
import { Box } from "@chakra-ui/layout"
import { SectionCard } from "./section-card"

export function SectionListing({ seo, isStory, location, sections = [] }) {
  return (
    <Box id="sectionListing" >
      {sections.map((s, index) => (
        <Box id={`sl${index}`} key={`sl${index}`}>
          <SectionCard sectionCard={s} isStory={isStory} eager={index === 0} seo={seo} location={location} />
        </Box>
      ))}
    </Box>
  )
}
